export const surveySteps = [
  {
    id: "you",
    title: "Quick intro",
    description: "Just the basics so we know who we're talking to.",
    fields: [
      { name: "firstName", label: "First name", type: "text", required: true, half: true },
      { name: "lastName", label: "Last name", type: "text", required: true, half: true },
      { name: "email", label: "Email", type: "email", required: true },
      { name: "role", label: "What do you do?", type: "text", required: true, placeholder: "e.g. Backend dev, CTO, Full-stack freelancer" },
      {
        name: "companyType",
        label: "Where do you work?",
        type: "select",
        required: true,
        options: ["Startup", "Scale-up / Growth stage", "Enterprise", "Agency / Consultancy", "Freelance / Solo", "Student", "Other"],
      },
      {
        name: "teamSize",
        label: "Engineering team size",
        type: "select",
        required: true,
        options: ["Just me", "2 - 5", "6 - 20", "21 - 50", "50+"],
      },
    ],
  },
  {
    id: "stack",
    title: "Your stack",
    description: "What do you use day to day? Tap all that apply.",
    fields: [
      {
        name: "ides",
        label: "IDE(s)",
        type: "multiselect",
        required: true,
        options: ["VS Code", "IntelliJ / WebStorm", "Vim / Neovim", "Cursor", "Zed", "Sublime Text", "Xcode", "Android Studio", "Other"],
      },
      {
        name: "hosting",
        label: "Where does your code run?",
        type: "multiselect",
        required: true,
        options: ["AWS", "Google Cloud", "Azure", "Vercel", "Netlify", "DigitalOcean", "Cloudflare", "Railway", "Fly.io", "Render", "Heroku", "Self-hosted", "Other"],
      },
      { name: "ideSatisfaction", label: "How happy are you with your current IDE?", type: "rating", required: true },
      { name: "hostingSatisfaction", label: "How happy are you with your current infrastructure?", type: "rating", required: true },
    ],
  },
  {
    id: "pain",
    title: "What's broken?",
    description: "This is the part that really helps us. Be honest.",
    fields: [
      { name: "biggestPainPoint", label: "What's the single most annoying thing in your dev workflow right now?", type: "textarea", required: true, minLength: 10 },
      {
        name: "ideFrustrations",
        label: "IDE frustrations (tap all that apply)",
        type: "multiselect",
        required: false,
        options: ["Slow / laggy", "Plugin conflicts", "Bad remote dev", "Expensive", "Heavy on RAM/CPU", "No cloud sync", "Poor collaboration", "Poor debugging", "Other"],
      },
      {
        name: "hostingFrustrations",
        label: "Infrastructure frustrations (tap all that apply)",
        type: "multiselect",
        required: false,
        options: ["Complex setup", "Unpredictable pricing", "Slow deploys", "Vendor lock-in", "Scaling issues", "Bad DX", "Poor docs", "Downtime", "Other"],
      },
      { name: "dreamFeature", label: "What one feature in a coding environment would genuinely make you excited to open it every morning?", type: "textarea", required: true, minLength: 10 },
      { name: "wishFeature", label: "If you could snap your fingers and fix one thing about your tools, what would it be?", type: "textarea", required: false, minLength: 10 },
      { name: "joinWaitlist", label: "Want early access when we launch something to fix this?", type: "toggle", required: false },
      { name: "newsletter", label: "Add me to the weekly infra & dev tools newsletter", type: "toggle", required: false },
      { name: "optInFollowUp", label: "Cool if we follow up?", type: "toggle", required: false },
    ],
  },
];
